function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
  fill: "#F0F0F0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12c0-6.628 12 0 12 0h12z",
  fill: "#D80027"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 12C0 5.373 5.373 0 12 0v12H0z",
  fill: "#0052B4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.144 4.174l.777 2.391h2.514L8.401 8.043l.777 2.392-2.034-1.478-2.035 1.478.777-2.392-2.034-1.478h2.515l.777-2.391z",
  fill: "#F0F0F0"
});

function SvgFlagCl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "/img/flag_cl.svg";
export { SvgFlagCl as ReactComponent };